import { Paper } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';
import { grey } from 'styles/Colors';

export const BpTaggingFlowWrapper = styled.div`
  height: 100%;
`;

export const HitTypeOffMessage = styled.span`
  display: block;
  font-family: Lato;
  font-size: 13px;
  letter-spacing: 0.5px;
  text-align: center;
  color: ${grey};
  margin-top: 50%;
`;

export const TaggingColumn = styled((props) => <Paper {...props} />)`
  height: 100%;
  padding: 6px 5px !important;
`;

export const PitchTypeToggle = styled.div`
  margin-left: auto;
  display: flex;
`;

export const Header = styled.div`
  display: flex;
`;

export const Label = styled.label`
  font-family: Lato;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.5px;
  color: #414141;
  margin-right: 10px;
  margin-top: 2px;
`;
